import React from 'react';
import { useTranslation } from 'react-i18next';
import MainLayout from '@/components/layout/MainLayout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Anchor, BarChart, CheckSquare, Package, Wrench, Bot, Ship } from 'lucide-react';

const SECTIONS = [
  { key: 'premiers-pas', icon: Anchor, ordered: true },
  { key: 'dashboard', icon: BarChart, ordered: false },
  { key: 'bateaux', icon: Ship, ordered: false },
  { key: 'inventaire', icon: Package, ordered: false },
  { key: 'maintenance', icon: Wrench, ordered: false },
  { key: 'checklists', icon: CheckSquare, ordered: false },
  { key: 'assistant', icon: Bot, ordered: false },
  { key: 'conseils', icon: null, ordered: false },
] as const;

const FAQPage = () => {
  const { t } = useTranslation('faq');

  return (
    <MainLayout>
      <div className="container mx-auto p-6 max-w-4xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-primary mb-4">{t('title')}</h1>
          <p className="text-muted-foreground">{t('subtitle')}</p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {SECTIONS.map((section) => {
            const Icon = section.icon;
            const intro = t(`sections.${section.key}.intro`);
            const items = t(`sections.${section.key}.items`, { returnObjects: true }) as string[];

            return (
              <AccordionItem key={section.key} value={section.key}>
                <AccordionTrigger className="text-left">
                  <div className="flex items-center gap-2">
                    {Icon && <Icon className="w-5 h-5 text-primary" />}
                    <span>{t(`sections.${section.key}.title`)}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent>
                  <Card>
                    <CardContent className="pt-4">
                      {intro && <p className="mb-4">{intro}</p>}
                      {section.ordered ? (
                        <ol className="space-y-2 text-sm list-decimal list-inside">
                          {items.map((item, i) => (
                            <li key={i} dangerouslySetInnerHTML={{ __html: item }} />
                          ))}
                        </ol>
                      ) : (
                        <ul className="space-y-2 text-sm">
                          {items.map((item, i) => (
                            <li key={i} dangerouslySetInnerHTML={{ __html: `• ${item}` }} />
                          ))}
                        </ul>
                      )}
                    </CardContent>
                  </Card>
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>

        <Card className="mt-8 bg-primary/5">
          <CardHeader>
            <CardTitle className="text-center">{t('help.title')}</CardTitle>
            <CardDescription className="text-center">{t('help.description')}</CardDescription>
          </CardHeader>
          <CardContent className="text-center">
            <p className="text-sm text-muted-foreground">
              {t('help.contact')} <span className="text-primary font-medium">contact@nauticoach.com</span>
            </p>
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default FAQPage;
